<template>
  <DropdownMenuPicker
    class="component-dropdown-language-picker"
    v-bind="$attrs"
    :list="languageConfig"
    @select="onSelectLanguage"
  >
    <template v-if="$slots.default">
      <slot />
    </template>
    <template v-else>
      <svg
        class="svgfont"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width="512"
        height="512"
        viewBox="0 0 512 512"
      >
        <path
          d="M256 16.001c-47.468 0-93.869 14.076-133.337 40.447s-70.229 63.854-88.394 107.709c-18.165 43.855-22.918 92.112-13.657 138.665 9.26 46.557 32.118 89.319 65.683 122.885 33.565 33.565 76.329 56.421 122.884 65.682s94.812 4.505 138.667-13.659c43.854-18.165 81.336-48.924 107.709-88.392 26.37-39.469 40.446-85.872 40.446-133.339 0-63.652-25.286-124.697-70.293-169.706-45.009-45.009-106.055-70.294-169.707-70.294v0zM461.712 238.858h-102.855c-2.001-63.136-18.36-124.986-47.829-180.857 40.605 11.107 76.824 34.404 103.77 66.744s43.32 72.171 46.914 114.113v0zM256 461.714c-3.823 0.258-7.661 0.258-11.486 0-35.516-56.637-55.226-121.746-57.085-188.571h137.142c-1.704 66.776-21.236 131.883-56.571 188.571-3.995 0.281-8.005 0.281-12 0zM187.429 238.858c1.706-66.776 21.237-131.883 56.571-188.571 7.633-0.858 15.339-0.858 22.971 0 35.697 56.585 55.587 121.698 57.599 188.571h-137.142zM200.457 58.001c-29.292 55.914-45.472 117.761-47.314 180.857h-102.858c3.595-41.942 19.971-81.771 46.916-114.113s63.165-55.637 103.769-66.744h-0.514zM51.142 273.142h102.858c1.789 63.080 17.911 124.929 47.142 180.858-40.476-11.226-76.546-34.575-103.362-66.906s-43.090-72.096-46.639-113.952v0zM311.029 454c29.469-55.872 45.828-117.723 47.829-180.858h102.855c-3.594 41.944-19.969 81.771-46.914 114.114-26.946 32.34-63.165 55.639-103.77 66.744z"
        />
      </svg>
    </template>
  </DropdownMenuPicker>
</template>

<script>
import commonMixins from '../mixins';
import DropdownMenuPicker from './DropdownMenuPicker';
import { REVERSE_LOCALE_MAP } from '~/frontend-shared/helper/const';

export const LANGUAGE_MAP = new Map([
  [
    'en',
    {
      show: true,
      value: 'en',
      title: 'English',
      sensorData: {
        sensorEventName: 'ClickTopBar',
        module_name: '选择语言',
        button_name: 'English',
      },
    },
  ],
  [
    'cn',
    {
      show: true,
      value: 'cn',
      title: '简体中文',
      sensorData: {
        sensorEventName: 'ClickTopBar',
        module_name: '选择语言',
        button_name: '简体中文',
      },
    },
  ],
  [
    'cn_tw',
    {
      show: true,
      value: 'cn_tw',
      title: '繁體中文',
      sensorData: {
        sensorEventName: 'ClickTopBar',
        module_name: '选择语言',
        button_name: '繁體中文',
      },
    },
  ],
  [
    'jp',
    {
      show: true,
      value: 'jp',
      title: '日本語',
      sensorData: {
        sensorEventName: 'ClickTopBar',
        module_name: '选择语言',
        button_name: '日本語',
      },
    },
  ],
  // [
  //   'kr',
  //   {
  //     show: true,
  //     value: 'kr',
  //     title: '한국어',
  //     sensorData: {
  //       sensorEventName: 'ClickTopBar',
  //       module_name: '选择语言',
  //       button_name: '한국어',
  //     },
  //   },
  // ],
  [
    'vn',
    {
      show: true,
      value: 'vn',
      title: 'Tiếng Việt',
      sensorData: {
        sensorEventName: 'ClickTopBar',
        module_name: '选择语言',
        button_name: 'Tiếng Việt',
      },
    },
  ],
  [
    'ru',
    {
      show: true,
      value: 'ru',
      title: 'Русский',
      sensorData: {
        sensorEventName: 'ClickTopBar',
        module_name: '选择语言',
        button_name: 'Русский',
      },
    },
  ],
  [
    'tr',
    {
      show: true,
      value: 'tr',
      title: 'Türkiye',
      sensorData: {
        sensorEventName: 'ClickTopBar',
        module_name: '选择语言',
        button_name: 'Türkiye',
      },
    },
  ],
  [
    'es',
    {
      show: true,
      value: 'es',
      title: 'Español',
      sensorData: {
        sensorEventName: 'ClickTopBar',
        module_name: '选择语言',
        button_name: 'Español',
      },
    },
  ],
  [
    'br',
    {
      show: true,
      value: 'br',
      title: 'Português',
      sensorData: {
        sensorEventName: 'ClickTopBar',
        module_name: '选择语言',
        button_name: 'Português',
      },
    },
  ],
]);

// 手动排序
export const LANGUAGE_LIST = [
  LANGUAGE_MAP.get('en'),
  LANGUAGE_MAP.get('cn'),
  // LANGUAGE_MAP.get('cn_tw'),
  // LANGUAGE_MAP.get('jp'),
  // // LANGUAGE_MAP.get('kr'),
  // LANGUAGE_MAP.get('vn'),
  // LANGUAGE_MAP.get('ru'),
  // LANGUAGE_MAP.get('tr'),
  // LANGUAGE_MAP.get('es'),
  // LANGUAGE_MAP.get('br'),
];

export default {
  name: 'DropdownLanguagePicker',

  components: {
    DropdownMenuPicker,
  },
  mixins: [commonMixins],

  computed: {
    routeLanguage() {
      return this.$route.params.lang;
    },
    inviteCode() {
      return this.$route.params.r;
    },
    languageList() {
      let list;
      if (!this.store.localeConfigList || !this.store.localeConfigList.length) {
        list = LANGUAGE_LIST;
      } else {
        list = this.store.localeConfigList.map(item => ({
          show: true,
          value: item.locale,
          name: item.name,
          sensorData: {
            sensorEventName: 'ClickTopBar',
            module_name: '选择语言',
            button_name: item.name,
          },
        }));
      }
      return list;
    },
    languageConfig() {
      return this.languageList.map((item) => ({
        ...item,
        selected: item.value === (REVERSE_LOCALE_MAP.has(this.store.locale) ? REVERSE_LOCALE_MAP.get(this.store.locale) : this.store.locale)
      }));
    },
  },

  methods: {
    onSelectLanguage(item) {
      this.$$switchLanguage(item.value);
    },
  },
};
</script>

<style lang="less" scoped>
@import '../assets/css/ui.variables.less';

.component-dropdown-language-picker {
  .svgfont {
    font-size: 16px;
  }
}
</style>
